const getParentZoom = (target: HTMLElement | null): number => {
    if (target === null) {
        return 1;
    }

    // TODO: zoom задеприкейчен. Стоит исследовать, нужен ли нам зум.
    const {
        // @ts-ignore
        zoom,
    } = window.getComputedStyle(target);

    const isZoomDefaultOrMissing = !zoom || zoom === '1';
    const hasParent = !!target.parentNode;
    const isBody = target.tagName === 'BODY';

    const canGoAhead = isZoomDefaultOrMissing && hasParent && !isBody;

    if (canGoAhead) {
        return getParentZoom(target.parentElement);
    }

    if (!zoom) {
        return 1;
    }

    return parseFloat(zoom);
};

interface IGetOffsetComponents {
    containerOffset: number;
    offset: number;
    zoom: number;
}

const getOffsetComponents = (
    container: HTMLElement | Document,
    target: HTMLElement
): IGetOffsetComponents => {
    const result = {
        containerOffset: 0,
        zoom: getParentZoom(target),
        offset: target.getBoundingClientRect().top,
    };

    if (container instanceof Document) {
        result.containerOffset = window.scrollY;

        return result;
    }

    // TODO отсюда и ниже не смог попасть тестами. Разобраться, нужен ли код
    if (getComputedStyle(container).position !== 'static') {
        result.offset = target.offsetTop;

        return result;
    }

    result.containerOffset = container.offsetTop;
    result.offset = target.getBoundingClientRect().top;

    return result;
};

const calcOffset = (container: HTMLElement | Document, target: HTMLElement): number => {
    const { containerOffset, offset, zoom } = getOffsetComponents(container, target);

    return offset * zoom + containerOffset;
};

const windowScroller = (offset: number): void => window.scrollTo(0, offset);

const getElementByHash = (hash: string): HTMLElement | null =>
    document.querySelector<HTMLElement>(`#${hash}`);

const scrollBase = ({
    getElement,
    calculateOffset = calcOffset,
    scrollHandler = windowScroller,
    name,
    options,
}: {
    calculateOffset: typeof calcOffset;
    getElement: typeof getElementByHash;
    name: string;
    options: {
        offset?: number;
    };
    scrollHandler: typeof windowScroller;
}): void => {
    const { offset = 0 } = options;
    const element = getElement(name);

    if (!element) {
        return undefined;
    }

    window.location.href = `#${name}`;

    return scrollHandler(calculateOffset(document, element) + offset);
};

export const scrollToHash = (name: string, options = {}): void =>
    scrollBase({
        getElement: getElementByHash,
        calculateOffset: calcOffset,
        scrollHandler: windowScroller,
        name,
        options,
    });
